(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pa-reviews"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__paReviews) return;
    window.__paReviews = true;

    var TS_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    var states = new WeakMap();

    function st(root) {
      var s = states.get(root);
      if (!s) {
        s = { token: null, widget: null, urlToken: null, busy: false };
        states.set(root, s);
      }
      return s;
    }
    function $(root, sel) { return root ? root.querySelector(sel) : null; }

    // Turnstile is loaded on the first open, never on page load.
    function loadTurnstile(cb) {
      if (window.turnstile) { cb(); return; }
      var s = document.querySelector('script[data-cf-turnstile]');
      if (!s) {
        s = document.createElement('script');
        s.src = TS_SRC;
        s.async = true;
        s.defer = true;
        s.setAttribute('data-cf-turnstile', '1');
        document.head.appendChild(s);
      }
      s.addEventListener('load', function () { cb(); }, { once: true });
    }

    function mountTurnstile(root) {
      var key = root.getAttribute('data-sitekey');
      var el = $(root, '[data-pa-turnstile]');
      if (!key || !el) return;
      var s = st(root);
      if (s.widget !== null) return;
      loadTurnstile(function () {
        if (!window.turnstile || s.widget !== null || !el.isConnected) return;
        s.widget = window.turnstile.render(el, {
          sitekey: key,
          action: 'review',
          callback: function (t) { s.token = t; },
          'expired-callback': function () { s.token = null; },
          'error-callback': function () { s.token = null; }
        });
      });
    }

    // A token is single-use: after any failed submit the widget must be reset.
    function resetTurnstile(root) {
      var s = st(root);
      s.token = null;
      if (window.turnstile && s.widget !== null) {
        try { window.turnstile.reset(s.widget); } catch (e) { /* widget gone */ }
      }
    }

    function openForm(root, focus) {
      var form = $(root, '[data-pa-form]');
      var btn = $(root, '[data-pa-write]');
      if (!form) return;
      form.hidden = false;
      if (btn) { btn.hidden = true; btn.setAttribute('aria-expanded', 'true'); }
      mountTurnstile(root);
      if (focus) {
        var first = $(form, 'input[name="rating"]');
        if (first) first.focus();
      }
    }

    function closeForm(root) {
      var form = $(root, '[data-pa-form]');
      var btn = $(root, '[data-pa-write]');
      if (form) form.hidden = true;
      if (btn) { btn.hidden = false; btn.setAttribute('aria-expanded', 'false'); btn.focus(); }
    }

    function setError(form, msg, field) {
      var e = $(form, '[data-pa-error]');
      if (e) { e.textContent = msg || ''; e.hidden = !msg; }
      if (field && field.focus) field.focus();
    }

    // Reviews follow the SKU. Horizon writes ?variant= to the URL on every
    // variant change, so that is the selected one at submit time.
    function skuFor(root) {
      var map = {};
      var el = $(root, '[data-pa-skus]');
      if (el) { try { map = JSON.parse(el.textContent || '{}'); } catch (e) { map = {}; } }
      var vid = new URLSearchParams(location.search).get('variant');
      return (vid && map[vid]) || root.getAttribute('data-sku') || '';
    }

    function submit(root, form) {
      var s = st(root);
      if (s.busy) return;
      setError(form, '');

      var rating = form.querySelector('input[name="rating"]:checked');
      if (!rating) { setError(form, 'Pick a star rating.', form.querySelector('input[name="rating"]')); return; }
      var bodyEl = form.elements.body;
      var body = (bodyEl.value || '').trim();
      if (body.length < 10) { setError(form, 'Tell us a little more about it (at least 10 characters).', bodyEl); return; }
      if (body.length > 4000) { setError(form, 'Reviews are capped at 4000 characters.', bodyEl); return; }
      var nameEl = form.elements.name;
      var name = (nameEl.value || '').trim();
      if (!name) { setError(form, 'Add your name.', nameEl); return; }
      var emailEl = form.elements.email;
      var email = (emailEl.value || '').trim();
      if (!email || !emailEl.validity.valid) { setError(form, 'Enter a valid email address.', emailEl); return; }
      if (root.getAttribute('data-sitekey') && !s.token) { setError(form, 'Please complete the security check above.'); return; }

      var payload = {
        sku: skuFor(root),
        rating: Number(rating.value),
        title: (form.elements.title.value || '').trim(),
        body: body,
        name: name,
        email: email,
        turnstileToken: s.token || '',
        website: form.elements.website ? (form.elements.website.value || '') : '',
        source: 'store'
      };
      if (s.urlToken) payload.token = s.urlToken;

      var btn = $(form, '[data-pa-submit]');
      var label = btn ? btn.textContent : '';
      s.busy = true;
      if (btn) { btn.disabled = true; btn.textContent = 'Sending...'; }

      function fail(msg) {
        s.busy = false;
        if (btn) { btn.disabled = false; btn.textContent = label; }
        resetTurnstile(root);
        setError(form, msg);
      }

      fetch(root.getAttribute('data-endpoint'), {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (res) {
        return res.text().then(function (t) {
          var d = null;
          try { d = t ? JSON.parse(t) : null; } catch (e) { d = null; }
          return { res: res, data: d };
        });
      }).then(function (r) {
        if (r.res.status === 202 || (r.res.ok && r.data && r.data.ok)) {
          s.busy = false;
          form.hidden = true;
          var done = $(root, '[data-pa-done]');
          if (done) { done.hidden = false; done.focus(); }
          return;
        }
        var msg = r.data && r.data.error
          ? String(r.data.error)
          : (r.res.status === 429
            ? 'Too many reviews from this connection right now. Please try again in a few minutes.'
            : 'Something went wrong on our side. Please try again.');
        fail(msg);
      }).catch(function () {
        fail('Could not reach the review service. Check your connection and try again.');
      });
    }

    // Delegated, so the handlers survive Horizon re-rendering the section.
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var w = t.closest('[data-pa-write]');
      if (w) { e.preventDefault(); openForm(w.closest('[data-pa-reviews]'), true); return; }
      var c = t.closest('[data-pa-cancel]');
      if (c) { e.preventDefault(); closeForm(c.closest('[data-pa-reviews]')); }
    });
    document.addEventListener('submit', function (e) {
      var form = e.target && e.target.closest ? e.target.closest('[data-pa-form]') : null;
      if (!form) return;
      e.preventDefault();
      submit(form.closest('[data-pa-reviews]'), form);
    });
    document.addEventListener('input', function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches('[data-pa-form] textarea[name="body"]')) return;
      var c = t.closest('form').querySelector('[data-pa-count]');
      if (c) c.textContent = String(t.value.length);
    });

    // Arrived from a review-request email: open the form, bring it into view,
    // and remember the token so the submission is marked a verified purchase.
    function init() {
      var token = new URLSearchParams(location.search).get('review');
      if (!token) return;
      var root = document.querySelector('[data-pa-reviews]');
      if (!root) return;
      st(root).urlToken = token;
      openForm(root, false);
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();
  } catch(e) { console.error(e); }
})();

})();
